import { render, staticRenderFns } from "./OrderSearchListMain.vue?vue&type=template&id=960be1a6&scoped=true&"
import script from "./OrderSearchListMain.vue?vue&type=script&lang=js&"
export * from "./OrderSearchListMain.vue?vue&type=script&lang=js&"
import style0 from "./OrderSearchListMain.vue?vue&type=style&index=0&id=960be1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960be1a6",
  null
  
)

/* custom blocks */
import block0 from "./OrderSearchListMain.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports